import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import { MailOutlineRounded, PhoneIphoneRounded } from '@mui/icons-material';
import { AuthLayout, SupportLink } from '../../components';
import {
  Heading,
  Title,
  SubTitle,
  Form,
  ModeToggle,
  ModeTab,
  FieldLabel,
  InputRow,
  CountrySelect,
  InputDivider,
  LoginInput,
  HelperText,
  ErrorText,
  ButtonApp,
} from './styles';

const countryOptions = [
  { value: '+57', flag: '🇨🇴' },
  { value: '+52', flag: '🇲🇽' },
];

const modes = [
  { value: 'telefono', label: 'Teléfono', icon: <PhoneIphoneRounded fontSize="small" /> },
  { value: 'correo', label: 'Correo', icon: <MailOutlineRounded fontSize="small" /> },
];

function Login({
  value,
  errorMsg,
  inputMode,
  countryCode,
  isValidInput,
  handleSubmit,
  onChangeMode,
  onChangeInput,
  onChangeCountryCode,
}) {
  const isPhone = inputMode === 'telefono';
  const fieldLabel = isPhone ? 'Número de celular' : 'Correo electrónico';

  return (
    <AuthLayout>
      <Heading>
        <Title component="h1">Bienvenido</Title>
        <SubTitle>Ingresa con tu celular o tu correo para ver tus motos.</SubTitle>
      </Heading>
      <Form onSubmit={handleSubmit} noValidate>
        <ModeToggle role="tablist" aria-label="Ingresar con">
          {modes.map((mode) => (
            <ModeTab
              key={mode.value}
              type="button"
              role="tab"
              aria-selected={inputMode === mode.value}
              active={inputMode === mode.value}
              onClick={() => onChangeMode(mode.value)}
            >
              {mode.icon}
              {mode.label}
            </ModeTab>
          ))}
        </ModeToggle>
        <div>
          <FieldLabel htmlFor="login-input">{fieldLabel}</FieldLabel>
          <InputRow>
            {isPhone ? (
              <>
                <CountrySelect
                  value={countryCode}
                  onChange={(event) => onChangeCountryCode(event.target.value)}
                  variant="standard"
                  disableUnderline
                  inputProps={{ 'aria-label': 'Indicativo del país' }}
                >
                  {countryOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {`${option.flag} ${option.value}`}
                    </MenuItem>
                  ))}
                </CountrySelect>
                <InputDivider />
              </>
            ) : null}
            <LoginInput
              key={inputMode}
              id="login-input"
              name={isPhone ? 'tel' : 'email'}
              value={value}
              onChange={onChangeInput}
              placeholder={isPhone ? '300 123 4567' : 'tucorreo@ejemplo.com'}
              type={isPhone ? 'tel' : 'email'}
              autoComplete={isPhone ? 'tel-national' : 'email'}
              autoFocus
              inputProps={{ inputMode: isPhone ? 'numeric' : 'email' }}
            />
          </InputRow>
          <HelperText>
            {isPhone
              ? 'Te enviaremos un código por WhatsApp.'
              : 'Te enviaremos un código a tu correo.'}
          </HelperText>
        </div>
        {errorMsg ? <ErrorText role="alert">{errorMsg}</ErrorText> : null}
        <ButtonApp
          type="submit"
          fullWidth
          variant="contained"
          disableElevation
          disabled={!isValidInput}
        >
          Continuar
        </ButtonApp>
      </Form>
      <SupportLink onDark />
    </AuthLayout>
  );
}

export default Login;
